var Container = require('./Container');
var Collection = require('Collection');

var Layer = Container.extend({

    initialize: function(){
        var that = this;
        that.objects = new Collection();
        Layer.__super__.initialize.apply(that, arguments);
    },

    loadObjects: function(options){
        var that = this;

        options || (options = {});

        if('raw' in options){
            delete options['raw']
        }
        return that.project.loadObjects(that.get('code'), options).then(function(objects){
            that.objects.reset(objects.getArray());
            return that.objects;
        })
    },

    loadObject: function(objectId, options){
        var that = this;
        options || (options = {});
        if('raw' in options){
            delete options['raw']
        }
        return that.project.loadObject(that.get('code'), objectId, options)
    }
});

module.exports = Layer;



//////////////////
// WEBPACK FOOTER
// ./src/Project/Layer.js
// module id = 14
// module chunks = 0